export const getAcronym = (name: string | undefined): string => {
  if (name) {
    const words = name.split(' ').slice(0, 2)
    const acr = words.map((word: string): string => word[0])
    return acr.join('').toUpperCase()
  }
  return ''
}

export const addComma = (text: string | null | undefined): string => {
  if (!text) {
    return ''
  }
  if (text.replaceAll(/\s/g, '') !== '') {
    return text.trim() + ', '
  }
  return ''
}
